import React, { Component } from "react";
import { Card, Container, CardBody, CardFooter, Icon, Button } from "design-react-kit";
import { NavLink, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { dateHelper, learningService, lessonTrainingService, networkErrorHelper } from "libs";
import { LESSON_ACTIVITY_TYPES, ROUTES, TD_IDLESSON } from "const";
import { BoxInfo, MnemoCallout, MnemoLoading, ModalHandler, SupportoTecnico } from "components/misc";
import TirocinioDirettoStep2 from "components/learning/TirocinioDirettoStep2";
import TirocinioDirettoStep4 from "components/learning/TirocinioDirettoStep4";

class TirocinioDirettoDetail extends Component {
  state = {
    loading: true,
    loadingError: false,
    tirocinioDiretto: null,
    tirocinioDirettoId: null,
    tirocinioDirettoRevision: null,
    idLesson: null,
    course: "",
    myCourse: "",
    myTraining: "",
    formActiveStep2: false,
    formActiveStep4: false,
    document: 0,
    defaultValues: {},
  };

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.rCode = rCode;

    this.loadCourse(rCode);
  }

  loadCourse(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const course = data.payload.course;
        const company = course.instituteCompany;
        const idLesson = TD_IDLESSON[company];

        this.setState({
          myCourse: data.payload.userCourse,
          course,
          idLesson,
        });

        this.loadTraining(idLesson, rCode);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({ loadingError: true, loading: false });
        }
      });
  }

  loadTraining(idLesson, rCode) {
    lessonTrainingService
      .myTraining(idLesson, rCode)
      .then(({ data }) => {
        this.setState({
          myTraining: data.payload.lessonTraining,
        });

        this.loadRemote(rCode, idLesson);
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({ loadingError: true, loading: false });
        }
      });
  }

  getPayload(status, formData) {
    const { myCourse, myTraining, tirocinioDirettoId, idLesson } = this.state;

    const payload = {
      userId: myCourse.userId,
      courseId: myCourse.courseId,
      lessonId: parseInt(idLesson),
      lessonType: "training",
      status,
      registrationCode: this.rCode,
      activityType: LESSON_ACTIVITY_TYPES.ABILITAZIONI,
      durata: myTraining.durata,
      tirocinioDirettoId,
      questions: formData,
    };

    return payload;
  }

  loadRemote(rCode, idLesson) {
    learningService
      .loadLessonActivity(rCode, idLesson)
      .then(({ data }) => {
        const tirocinioDiretto = data.payload.activity;
        const tirocinioDirettoRevision = data.payload.activityRevision;
        const questions = tirocinioDiretto.questions;

        const { defaultValues } = this.state;

        const newState = {
          tirocinioDiretto,
          tirocinioDirettoRevision,
          tirocinioDirettoId: tirocinioDiretto.id,
          loading: false,
        };

        questions.forEach((q) => {
          if (q.field) {
            defaultValues[q.field] = q.answer ?? "";
            newState[q.field] = q.answer ?? "";
          }
        });

        newState.defaultValues = {
          ...defaultValues,
          document: tirocinioDiretto.id,
        };

        this.setState(newState);
      })
      .catch((error) => {
        if (networkErrorHelper.is404(error)) {
          this.createDraft();
        } else {
          networkErrorHelper.notify(error);
          this.setState({
            loadingError: true,
            loading: false,
          });
        }
      });
  }

  getFile = (code) => {
    const { tirocinioDiretto } = this.state;
    const file = tirocinioDiretto?.files?.find((f) => f.code === code);

    return file;
  };

  createDraft = async () => {
    const payload = this.getPayload("draft");

    learningService
      .insertTirocinioDiretto(payload)
      .then(({ data }) => {
        const tirocinioDiretto = data.payload.tirocinioDiretto;
        const tirocinioDirettoId = tirocinioDiretto.id;

        this.setState({
          tirocinioDiretto,
          tirocinioDirettoId,
          defaultValues: {
            ...this.state.defaultValues,
            document: tirocinioDirettoId,
          },
          loading: false,
        });
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  saveRemote = (status, formData) => {
    ModalHandler.show(
      null,
      "Conferma",
      "Dopo aver confermato, le informazioni fornite verranno salvate definitivamente e non sarà più possibile inviarle nuovamente. Vuoi procedere?",
      null,
      () => this.saveConfirmed(status, formData),
    );
  };

  saveConfirmed = async (status, formData) => {
    const { rCode } = this;
    const { idLesson } = this.state;

    const payload = this.getPayload(status, formData);

    learningService
      .updateTirocinioDiretto(payload)
      .then(() => {
        this.setState({ formActiveStep2: false, formActiveStep4: false });
        this.loadRemote(rCode, idLesson);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  toggleEditStep2 = () => {
    const { formActiveStep2, idLesson } = this.state;
    const { rCode } = this;

    if (formActiveStep2) {
      this.loadRemote(rCode, idLesson);
    }

    this.setState({ formActiveStep2: !formActiveStep2 });
  };

  toggleEditStep4 = () => {
    const { formActiveStep4, idLesson } = this.state;
    const { rCode } = this;

    if (formActiveStep4) {
      this.loadRemote(rCode, idLesson);
    }

    this.setState({ formActiveStep4: !formActiveStep4 });
  };

  renderStep1Download = () => {
    const { course, myCourse } = this.state;
    const company = course.instituteCompany;
    const cfuTD = myCourse.cfuTD;

    return (
      <section className="my-4">
        <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
          <div className="flag-icon" />
          <div className="etichetta">
            <Icon icon="it-user" padding={false} />
            <span>Download dei documenti necessari per l'avvio del tirocinio diretto</span>
          </div>
          <CardBody tag="div">
            <ul>
              <li>
                <a
                  href="https://www.formazionedocenti.it/files/tirocinio_diretto/linee_guida_tirocinio_diretto.pdf"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Linee guida
                </a>
              </li>
              <li>
                <a
                  href={`https://www.formazionedocenti.it/files/tirocinio_diretto/${company}_Progetto_formativo_${cfuTD}CFU.pdf`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Progetto formativo
                </a>
              </li>
              <li>
                <a
                  href={`https://www.formazionedocenti.it/files/tirocinio_diretto/${company}_convenzione.pdf`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Convenzione
                </a>
              </li>
              <li>
                <a
                  href={`https://www.formazionedocenti.it/files/tirocinio_diretto/${company}_griglia_autovalutazione.pdf`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Griglia di autovalutazione
                </a>
              </li>
              <li>
                <a
                  href={`https://www.formazionedocenti.it/files/tirocinio_diretto/${company}_registro_presenze.pdf`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Registro presenze
                </a>
              </li>
            </ul>
          </CardBody>
        </Card>
      </section>
    );
  };

  renderStep2Upload = () => {
    const {
      tirocinioDiretto,
      tirocinioDirettoRevision,
      formActiveStep2,
      schoolName,
      schoolCode,
      schoolAddress,
      schoolCity,
      schoolCap,
      schoolEmail,
      schoolPec,
      schoolProvince,
      dateEnd,
      course,
      defaultValues,
    } = this.state;

    const isEditable = tirocinioDiretto?.status === "draft" || tirocinioDiretto?.status === "approvePending";

    const progetto = this.getFile("progettoFormativo");
    const convenzione = this.getFile("convenzione");
    const contratto = this.getFile("contrattoLavoro");

    return (
      <section className="my-4">
        <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
          <div className="flag-icon" />
          <div className="etichetta">
            <Icon icon="it-user" padding={false} />
            <span>Upload documenti necessari per l'avvio del tirocinio</span>
          </div>
          <CardBody tag="div">
            {tirocinioDiretto?.status === "approvePending" && tirocinioDirettoRevision.revisionNote && (
              <MnemoCallout className="mnemo-callout-danger w-100 mb-4">
                <h5 className="text-red">ATTENZIONE: Documentazione non idonea</h5>
                <i>{tirocinioDirettoRevision.revisionNote}</i>
              </MnemoCallout>
            )}

            {formActiveStep2 && isEditable ? (
              <TirocinioDirettoStep2
                tirocinioDiretto={tirocinioDiretto}
                formActive={formActiveStep2}
                defaultValues={defaultValues}
                dateEnd="2026-09-30"
                onSubmit={(questions) => this.saveRemote("toApprove", questions)}
                onToggleEdit={this.toggleEditStep2}
                company={course.instituteCompany}
              />
            ) : (
              <Container>
                <h4 className="mb-3">Dati Istituto</h4>
                {schoolName && (
                  <p>
                    <b>Denominazione:</b> {schoolName}
                  </p>
                )}

                {schoolCode && (
                  <p>
                    <b>Codice meccanografico: </b> {schoolCode}
                  </p>
                )}

                {(schoolAddress || schoolCity) && (
                  <p>
                    <b>Sede:</b> {schoolAddress}
                    {schoolCap ? `, ${schoolCap}` : ""} - {schoolCity} ({schoolProvince})
                  </p>
                )}

                {schoolEmail && (
                  <p>
                    <b>E-mail:</b> {schoolEmail}
                  </p>
                )}

                {schoolPec && (
                  <p>
                    <b>PEC:</b> {schoolPec}
                  </p>
                )}

                <hr />

                {dateEnd && (
                  <p>
                    <b>Data fine tirocinio: </b> {dateHelper.toITDate(dateEnd)}
                  </p>
                )}

                <p>
                  <b>Progetto formativo:</b>{" "}
                  {progetto?.fileUrl ? (
                    <a href={`${process.env.REACT_APP_API_URL}${progetto.fileUrl}`} rel="noopener noreferrer" target="_blank">
                      Vedi file
                    </a>
                  ) : (
                    "Non ancora caricato"
                  )}
                </p>
                <p>
                  <b>Convenzione:</b>{" "}
                  {convenzione?.fileUrl ? (
                    <a href={`${process.env.REACT_APP_API_URL}${convenzione.fileUrl}`} rel="noopener noreferrer" target="_blank">
                      Vedi file
                    </a>
                  ) : (
                    "Non ancora caricato"
                  )}
                </p>

                {this.state.isSchoolAccredited === "2" && (
                  <p>
                    <b>Contratto di lavoro:</b>{" "}
                    {contratto?.fileUrl ? (
                      <a href={`${process.env.REACT_APP_API_URL}${contratto.fileUrl}`} rel="noopener noreferrer" target="_blank">
                        Vedi file
                      </a>
                    ) : (
                      "Non ancora caricato"
                    )}
                  </p>
                )}

                <CardFooter>
                  {isEditable ? (
                    <Button color="primary bg-dark" className="float-right" onClick={this.toggleEditStep2}>
                      Carica / Modifica documenti
                    </Button>
                  ) : (
                    <p>
                      Documenti non modificabili, in caso di problemi <SupportoTecnico />
                    </p>
                  )}
                </CardFooter>
              </Container>
            )}
          </CardBody>
        </Card>
      </section>
    );
  };

  renderStep3CompanyDocuments = () => {
    /**
     In questa sezione è possibile scaricare i documenti controfirmati dall'università, 
     necessari per l'avvio del tirocinio diretto.
    */

    const { tirocinioDiretto } = this.state;
    const status = tirocinioDiretto?.status;

    const isSigned = ["approved", "confirmed", "revisioned", "revisionPending"].includes(status);
    const isToApprove = status === "toApprove";

    const progettoSigned = this.getFile("progettoFormativo_signed");
    const convenzioneSigned = this.getFile("convenzione_signed");

    return (
      <section className="my-4">
        <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
          <div className="flag-icon" />
          <div className="etichetta">
            <Icon icon="it-user" padding={false} />
            <span>Documentazione controfirmata dall'Università</span>
          </div>
          <CardBody tag="div">
            {isSigned ? (
              <>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <strong>Progetto formativo:</strong>{" "}
                    {progettoSigned?.fileUrl ? (
                      <a href={`${process.env.REACT_APP_API_URL}${progettoSigned.fileUrl}`} target="_blank" rel="noopener noreferrer">
                        Scarica
                      </a>
                    ) : (
                      "File mancante"
                    )}
                  </li>
                  <li>
                    <strong>Convenzione:</strong>{" "}
                    {convenzioneSigned?.fileUrl ? (
                      <a href={`${process.env.REACT_APP_API_URL}${convenzioneSigned.fileUrl}`} target="_blank" rel="noopener noreferrer">
                        Scarica
                      </a>
                    ) : (
                      "File mancante"
                    )}
                  </li>
                </ul>
              </>
            ) : isToApprove ? (
              <BoxInfo>
                I documenti sono in fase di verifica. Una volta approvati dall'università, potrai scaricare qui le versioni controfirmate.
              </BoxInfo>
            ) : (
              <BoxInfo>Documenti non ancora disponibili. Carica i file nella sezione "Caricamento documenti" per avviare la procedura.</BoxInfo>
            )}
          </CardBody>
        </Card>
      </section>
    );
  };

  renderStep4TD = () => {
    /**
     * In questa sezione è possibile caricare tutti i dati del tirocinio diretto
     */

    const { tirocinioDiretto, tirocinioDirettoRevision, formActiveStep4, defaultValues, numHours, dateEnd, dateStart } = this.state;

    const status = tirocinioDiretto?.status;
    const isActive = ["approved", "confirmed", "revisioned", "revisionPending"].includes(status);
    const isEditable = status === "approved" || status === "revisionPending";

    const relazione = this.getFile("relazioneFinale");
    const registro = this.getFile("registroPresenze");
    const griglia = this.getFile("grigliaAutovalutazione");

    return (
      <section className="my-4">
        <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
          <div className="flag-icon" />
          <div className="etichetta">
            <Icon icon="it-user" padding={false} />
            <span>Upload documentazione a conclusione del tirocinio</span>
          </div>

          <CardBody tag="div">
            {status === "revisionPending" && tirocinioDirettoRevision.revisionNote && (
              <MnemoCallout className="mnemo-callout-danger w-100 mb-4">
                <h5 className="text-red">ATTENZIONE: Documentazione non idonea</h5>
                <i>{tirocinioDirettoRevision.revisionNote}</i>
              </MnemoCallout>
            )}

            {!isActive ? (
              <BoxInfo>Area attiva dopo l'approvazione dei documenti da parte dell'Università.</BoxInfo>
            ) : formActiveStep4 && isEditable ? (
              <>
                <TirocinioDirettoStep4
                  tirocinioDiretto={tirocinioDiretto}
                  formActive={formActiveStep4}
                  defaultValues={defaultValues}
                  onSubmit={(questions) => this.saveRemote("confirmed", questions)}
                  onToggleEdit={this.toggleEditStep4}
                />
              </>
            ) : (
              <Container>
                {numHours && (
                  <p>
                    <b>Numero ore tirocinio: </b> {numHours}
                  </p>
                )}
                {dateStart && (
                  <p>
                    <b>Data inizio tirocinio: </b> {dateHelper.toITDate(dateStart)}
                  </p>
                )}
                {dateEnd && (
                  <p>
                    <b>Data fine tirocinio: </b> {dateHelper.toITDate(dateEnd)}
                  </p>
                )}

                <p>
                  <b> Relazione finale:</b>{" "}
                  {relazione?.fileUrl ? (
                    <a href={`${process.env.REACT_APP_API_URL}${relazione.fileUrl}`} rel="noopener noreferrer" target="_blank">
                      Vedi file
                    </a>
                  ) : (
                    "Non ancora caricato"
                  )}
                </p>
                <p>
                  <b> Registro presenze:</b>{" "}
                  {registro?.fileUrl ? (
                    <a href={`${process.env.REACT_APP_API_URL}${registro.fileUrl}`} rel="noopener noreferrer" target="_blank">
                      Vedi file
                    </a>
                  ) : (
                    "Non ancora caricato"
                  )}
                </p>
                <p>
                  <b> Griglia autovalutazione:</b>{" "}
                  {griglia?.fileUrl ? (
                    <a href={`${process.env.REACT_APP_API_URL}${griglia.fileUrl}`} rel="noopener noreferrer" target="_blank">
                      Vedi file
                    </a>
                  ) : (
                    "Non ancora caricato"
                  )}
                </p>
                <CardFooter>
                  {isEditable ? (
                    <Button color="primary bg-dark" className="float-right" onClick={this.toggleEditStep4}>
                      Carica / Modifica documenti
                    </Button>
                  ) : (
                    <p>
                      Dati non modificabili, in caso di problemi <SupportoTecnico />
                    </p>
                  )}
                </CardFooter>
              </Container>
            )}
          </CardBody>
        </Card>
      </section>
    );
  };

  render() {
    const { loading } = this.state;

    if (loading) return <MnemoLoading />;

    return (
      <>
        <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${this.rCode}`} className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>

        <Container className="my-4">
          <h1>Tirocinio Diretto</h1>
          {this.renderStep1Download()}
          {this.renderStep2Upload()}
          {this.renderStep3CompanyDocuments()}
          {this.renderStep4TD()}
        </Container>
      </>
    );
  }
}

export default withRouter(TirocinioDirettoDetail);
